import React from "react";

const Hero = () => {

  return (
    <div className="text-center py-24 lg:py-32 relative">
      <h1 className="text-4xl lg:text-6xl xl:text-7xl lg:tracking-[-6px] font-popinsBold text-themeColor w-[90%] mx-auto">
        Master Your <span className="text-btnColor">Management</span> with Ease
      </h1>
      <p className="font-popinsRegular text-textColor text-base lg:text-lg w-[90%] lg:w-[65%] mx-auto pt-5">
        Explore our Help & Tutorials for step-by-step guidance.
      </p>
      <div className="absolute left-0 bottom-10 size-40 xl:size-48 2xl:size-44 hidden lg:block">
        <img src="/assets/hero.png" alt="" className="size-full object-fill" />
      </div>
    </div>
  );
};

export default Hero;
